// core
import React from "react";
import styles from "./Checkbox.module.scss";
import cx from "classnames";
import IBaseFormComponentProps from "../../../interfaces/IBaseFormComponentProps";
import InputWrapper from "../InputWrapper/InputWrapper";

interface ICheckbox
    extends Omit<IBaseFormComponentProps<HTMLInputElement, boolean>, "value"> {
    id?: string;
    size: "m" | "l" | "2xl";
    checked: boolean;
    tabIndex?: number;
}

const Checkbox: React.FC<ICheckbox> = (props) => {
    const {
        id,
        name,
        size,
        label,
        className,
        checked,
        onChange,
        onBlur,
        isDisabled,
        hasError,
        tooltipContent
    } = props;

    return (
        <InputWrapper
            className={cx("layout-flex-row--centered", { [className]: !!className })}
            isDisabled={isDisabled}
            hasError={hasError}
            tooltipContent={tooltipContent}
            isFullWidth={false}>
            <label
                className={cx(styles["checkbox"], "text-no-bold")}
                htmlFor={id || name}>
                <input
                    id={id || name}
                    type="checkbox"
                    checked={checked}
                    className={cx({
                        ["cursor-default"]: isDisabled
                    })}
                    onChange={(e) => {
                        if (isDisabled) return;
                        onChange(e);
                    }}
                    onBlur={onBlur}
                    name={name}
                />

                <div
                    className={cx(
                        styles["checkbox__display"],
                        "layout-flex-row--centered",
                        "flex-gap-s",
                        "text-font-size-s"
                    )}>
                    <div
                        className={cx(
                            styles["checkbox__display--inner"],
                            styles[`checkbox-size-${size}`]
                        )}
                    />
                    {label}
                </div>
            </label>
        </InputWrapper>
    );
};

export default Checkbox;
